export default {
  camera: {
    left: {
      notes: 'Label for left camera position in 3d model viewer',
      message: 'Left',
    },
    right: {
      notes: 'Label for right camera position in 3d model viewer',
      message: 'Right',
    },
  },
  missingModel: {
    notes: 'Label in empty state when no 3d model exists',
    message: 'No 3d model available',
  },
};
